module.exports = "https://static.cdns.space/tarot-temp/img/the-chariot.a4d53b81.webp";